import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import IExpressService from '../../../../interfaces/sendReceipt/expressServices';
import { H2 } from '../../../base/typography';
import * as StyledDelivery from './delivery.styles';
import Services from './services';

interface Props {
	values: any;
	setFieldTouched: any;
	setFieldValue: any;
	isValid: boolean;
	errors: any;
	services: IExpressService[];
}

const Delivery: FC<Props> = ({ values, setFieldValue, setFieldTouched, errors, services }) => {
	const { t } = useTranslation('sendReceipt');
	const servicesLoading = false;
	return (
		<StyledDelivery.Wrapper>
			<H2>{t('delivery')}</H2>
			<StyledDelivery.OptionalServicesWrapper>
				<Services
					services={services}
					loading={servicesLoading}
					setFieldValue={setFieldValue}
					values={values}
					errors={errors}
					setFieldTouched={setFieldTouched}
				/>
			</StyledDelivery.OptionalServicesWrapper>
		</StyledDelivery.Wrapper>
	);
};

export default Delivery;
